import * as THREE from 'three'
import { useFrame } from '@react-three/fiber'
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function useUpdateAnimal(animalRef, animalName, actions) {

    const {
        currentPosition,
        currentRotation,
    } = useAppStore( useShallow((state) => ({
        currentPosition: state.positions[animalName]?.current,
        currentRotation: state.rotations[animalName],
    })));

    const quaternion = new THREE.Quaternion();

    useFrame(() => {
        if (
            animalRef.current.position.x !== currentPosition.x ||
            animalRef.current.position.y !== currentPosition.y ||
            animalRef.current.rotation.z !== currentRotation
        ) {
            animalRef.current.position.lerp(currentPosition, currentPosition.y < -10 ? 0.05 : 0.8);
            quaternion.setFromEuler(currentRotation);
            animalRef.current.quaternion.slerp(quaternion, 0.5);
        }
    });
};
